import React from "react";
import ParticlesBg from "particles-bg";

const BackgroundComponent = () => {
    let config = {
        num: [1, 5],
        rps: 0.1,
        radius: [30, 70],
        life: [2.0, 5],
        v: [0.1, .5],
        tha: [-120, 100],
        alpha: [0.45, 0.03],
        scale: [.1, 0.6],
        position: "all",
        color: ["#F9E794", "#FFEEDB", "#F6BED4", "#9B9DC9", "#FFEEDB"],
        cross: "dead",
        g: 0.2,
        random: 0.1
    };

    return (
        <ParticlesBg type="custom"
                     bg={true}
                     config={config}/>
    )

}
export default BackgroundComponent